/**
 * This week's quests for Home (specs/home-page Story 4). Progress changes as the player acts
 * elsewhere in the app, so it goes stale quickly and is refetched on focus by the screen.
 */

import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../helpers/apiClient.helper';
import { fetchWeeklyQuests } from '../helpers/homeApi';
import { homeQueryKeys } from '../constants/homeQueryKeys';
import { HOME_QUESTS_STALE_TIME_MS, HOME_QUERY_GC_TIME_MS } from '../constants/home.constants';

export const useWeeklyQuestsQuery = (userId: string | null, enabled: boolean = true) => {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: homeQueryKeys.quests(userId),
    queryFn: () => fetchWeeklyQuests(apiClient),
    enabled: enabled && !!userId,
    staleTime: HOME_QUESTS_STALE_TIME_MS,
    gcTime: HOME_QUERY_GC_TIME_MS,
    retry: 2,
  });
};
